export const news = {
  newsFeedCreateInputPlaceholder: 'Scrivi un post...',
  newsFeedSearchInputPlaceholder: 'Cerca',
  newsFeedPostOwnerCurtainEditTitle: 'Modifica post',
  newsFeedPostOwnerCurtainDeleteTitle: 'Elimina post',
  newsFeedEditedPostSavedAlertText: 'Post salvato!',
  newsFeedEditedPostDeletedAlertText: 'Post eliminato!',
  newsFeedShareCurtainOptionTitle: 'Copia link',
  newsFeedPostLinkCopiedAlertText: 'Link copiato!',
  newsFeedOthersPostCurtainOptionCopyTitle: 'Copia link',
  newsFeedOthersPosLinkCopiedAlertText: 'Link copiato!',
  newsFeedOthersPostCurtainOptionFlagTitle: 'Segnala contenuto',
  newsFeedOtherPostOwnersCurtainDeleteTitle: 'Elimina post',
  newsFeedPostDeletePopupTitle: 'Elimina',
  newsFeedPostDeletePopupText: 'Eliminare questo post?',
  newsFeedPostDeletePopupCancelButtonTitle: 'Annulla',
  newsFeedPostDeletePopupConfirmButtonTitle: 'Conferma',
  newsFeedPostDeeletedAlertText: 'Post eliminato!',
  newsPostDetailsHeaderTitle: 'Post',
  postFeedPostLikesText: 'Mi piace',
  postFeedPostCommentsText: 'Commenti',
  postFeedPostNoLikesText: 'Non ci sono ancora Mi piace',
  postFeedPostLeaveFirstLikeText: 'Puoi essere il primo a mettere Mi piace',
  newsFeedPostDetailsNoCommentsText: 'Non ci sono ancora commenti',
  newsFeedPostDetailsFirstCommentText: 'Puoi essere il primo a commentare',
  newsFeedPostDetailsShareOptionTitle: 'Copia link',
  newsFeedPostDetailsSharePostCopiedAlertText: 'Link copiato!',
  newsFeedPostDetailsUsersCurtainCopyOptionTitle: 'Copia link',
  newsFeedPostDetailsCopiedAlertText: 'Link copiato!',
  newsFeedPostDetailsUsersCurtainFlagOptionTitle: 'Segnala contenuto',
  newsPostDetailsFlagCurtainOptionSpamTitle: 'Segnala',
  newsPostDetailsReportedCurtainText: 'Contenuto segnalato',
  newsPostDetailsCommentOwnerCurtainEditOptionTitle: 'Modifica commento',
  newsPostDetailsCommentOwnerCurtainDeleteOptionTitle: 'Elimina commento',
  newsPostDetailsEditedCommentSavedAlertText: 'Commento salvato!',
  postDetailsOtherCommentAppOwnerCurtainOptionTitle: 'Elimina commento',
  postDetailsOtherUsersCommentDeletadAlertText: 'Commento eliminato!',
  postDetailsDeleteCommentPopupTitle: 'Elimina',
  postDetailsDeleteCommentPopupText: 'Eliminare questo commento?',
  postDetailsDeleteCommentPopupCancelButtonTitle: 'Annulla',
  postDetailsDeleteCommentPopupConfirmlButtonTitle: 'Conferma',
  postDetailsCommDeletedAlertText: 'Commento eliminato!',
  postDetailsCommentUserCurtainOptionTitle: 'Segnala commento',
  newsCreatePostCurtainTitle: 'Nuovo post',
  newsCreatePostCurtainBodyPlaceholder: 'Inserisci il tuo testo qui...',
  newsCreatePostPublishButtonTitle: 'Pubblica',
  newsCreatePostUploadSlallerImageAlertText: 'Puoi caricare al massimo {size} MB alla volta',
  newsPostSavedAlertText: 'Post salvato!',
  newsCreatePostAddLocationCurtainTitle: 'Posizione',
  newsCreatePostAddLocationCurtainInputPlaceholder: 'Nome posizione',
  newsCreatePostEditLocationCurtainText: 'Modifica posizione',
  newsDeleteLocation: 'Elimina posizione',
  newsDiscardPostPopupTitle: 'Bozza',
  newsDiscardPostPopupText: 'Eliminare questa bozza?',
  newsDiscardPostPopupCancelButtonTitle: 'Annulla',
  newsDiscardPostPopupCofirmButtonTitle: 'Conferma',
  newsNewPostCreatePollTitle: 'Crea sondaggio',
  newsNewPostCreatePollTitleInputPlaceholder: 'Titolo',
  newsNewPostCreatePollOptionInputPlaceholder: 'Opzione',
  newsNewPostCreatePollAddButtonTitle: 'Aggiungi opzione',
  newsNewPostCreatePollCreateButtonTitle: 'Crea',
  newsCreatePostPollTitleBlankAlertText: 'Il titolo non può essere vuoto!',
  newsCreatePostPollOptionBlankAlertText: "L'opzione non può essere vuota!",
  newsCreatePostPollLongTitleAlertText: 'Il titolo può contenere al massimo {length} caratteri',
  newsCreatePostPollLongOptionAlertText: "L'opzione può contenere al massimo {length} caratteri",
  newsCreatePostPollEditOptionTitle: 'Modifica sondaggio',
  newsCreatePostPollRemoveOptionTitle: 'Rimuovi sondaggio',
  newsPostPollInfoVotesText: 'voti',
  newsPostPollInfoEditVoteText: 'Modifica voto',
  newsPostPollFinishPollText: 'Termina il sondaggio',
  newsPostPollFinishedPollText: 'Terminato',
  newsPostPollInProgresslText: 'In corso',
  newsFinishPollCurtainTitle: 'Termina il sondaggio',
  newsFinishPollCurtainText: 'Gli utenti non potranno più votare dopo la chiusura del sondaggio.',
  newsFinishPollCurtainCancelButtonTitle: 'Annulla',
  newsFinishPollCurtainConfirmlButtonTitle: 'Conferma',
  newsPollInfoPollVotesCurtainTitle: 'Risultati del sondaggio',
  newsEditPostCurtainTitle: 'Modifica post',
  newsEditPostCurtainNoTextBodyPlaceholder: 'Inserisci il tuo testo qui...',
  newsEditPostCurtainSaveButtonTitle: 'Salva',
  newsEditPostSavedAlertText: 'Post salvato!',
  newsError: 'Si è verificato un errore!',
  newsAt: 'alle',
  newsSeeMore: 'Mostra di più...',
  newsMaxAttachments: 'Hai superato il numero massimo di allegati. Il massimo di allegati è {length}',
  newsReply: 'Rispondi',
  newsPin: 'Fissa post',
  newsUnpin: 'Scollega post'
}
